import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  fill: "none",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M48 11v28H2V11zm0-2H2c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h46c1.1 0 2-.9 2-2V11c0-1.1-.9-2-2-2" }),
      _createElementVNode("path", { d: "m20.67 19.23 10 5.77-10 5.77V19.22m0-1.99a2.003 2.003 0 0 0-2 2v11.55a2.003 2.003 0 0 0 2 2c.35 0 .69-.09 1-.27l10-5.77c.62-.36 1-1.02 1-1.73s-.38-1.37-1-1.73l-10-5.77c-.31-.18-.65-.27-1-.27z" })
    ], -1)
  ])))
}
export default { render: render }